export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            Czym jest Kakobuy Spreadsheet?
          </h2>
          <p className="text-base text-foreground-600 max-w-3xl mx-auto leading-relaxed">
            Kakobuy Spreadsheet to specjalnie przygotowana lista produktów, która pomaga użytkownikom
            szybciej znaleźć najlepsze oferty. Zamiast godzinami przeszukiwać tysiące produktów,
            możesz korzystać z uporządkowanej bazy zawierającej:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {[
            {
              icon: 'ri-file-list-3-line',
              title: 'Lista produktów',
              desc: 'Szybsze znalezienie ofert bez wielogodzinnego przeszukiwania stron',
            },
            {
              icon: 'ri-folder-5-line',
              title: 'Kategorie',
              desc: 'Łatwa nawigacja po uporządkowanych sekcjach produktowych',
            },
            {
              icon: 'ri-links-line',
              title: 'Linki zakupowe',
              desc: 'Jeden klik do produktu — bez kopiowania i wklejania adresów',
            },
            {
              icon: 'ri-image-line',
              title: 'Zdjęcia QC',
              desc: 'Kontrola jakości produktów przed złożeniem zamówienia',
            },
            {
              icon: 'ri-refresh-line',
              title: 'Aktualizacje',
              desc: 'Regularnie dodawane nowe okazje i produkty w atrakcyjnych cenach',
            },
            {
              icon: 'ri-star-line',
              title: 'Sprawdzone oferty',
              desc: 'Tylko zweryfikowane produkty od zaufanych sprzedawców',
            },
          ].map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-colors group"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}